import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'

const styles = () => ({
  container: {
    width: '100%',
    height: '100%',
  },
  logo: {
    width: '100%',
    maxWidth: 100,
    minWidth: 48,
    maxHeight: 45,
    height: '100%',
    objectFit: 'contain',
  },
})

const Logo = ({classes, goHome}) => (
  <div className={classes.container} onClick={() => {}}>
    <a href={'https://space.guru/'}>
      <img src="/assets/headerlogo.png" className={classes.logo} alt="logo"/>
    </a>
  </div>
)

Logo.propTypes = {
  goHome: PropTypes.func.isRequired,
}

export default withStyles(styles)(Logo)



// WEBPACK FOOTER //
// ./src/sections/header/components/logo.js